import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { Table } from "antd";
import { useNavigate } from "react-router-dom";
import DelTableRowModal from "../../../modals/delTableRowModal";
import { useTranslation } from "react-i18next";
import { getCaseById, getClientById } from "../../../APIs/clientApis";
import { useParams } from "react-router-dom";

const data = [
  {
    // key: "1",
    // incidentID: "2501",
    // caseHistory: "07.01.2025",
    // // doc: "Police report - contact client for witness statement",
    // relatedCases: "Police report- contact client for witness statement. ",
    // billingFees: "N/A",
    // lawyerNote: "Send witness statements by 15.01.2025. ",
  },
  {
    // key: "2",
    // incidentID: "2502",
    // caseHistory: "11.01.2025",
    // // doc: "High Court enforcement invoice - court fees",
    // relatedCases: "Police report- contact client for witness statement. ",
    // billingFees: "£148",
    // lawyerNote: "Need to pay by 20.01.2025. ",
  },
];

const OverviewTable = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isdelModalOpen, setIsdelModalOpen] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [clientData, setClientData] = useState(null);
  const { caseId } = useParams();
  console.log("OverviewTable - Case ID from useParams:", caseId);

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log("jjjjjjjjjj Fetching data for case ID:", caseId );

        if (!caseId) {
          console.warn("No caseId found");
          return;
        }

        // Fetch case data
        const caseResponse = await getCaseById(caseId);
        console.log("hhhhhhhhhhhhh Case API Response:", caseResponse);

        // Fetch client data
        // const clientResponse = await getClientById(clientId);
        // console.log("Client API Response:", clientResponse);

        // Transform case data for the table
        const formattedData = caseResponse.data.map((item, index) => ({
          key: index + 1,
          incidentID: item.id_no,
          caseHistory: item.date,
          doc: item.document, // Adjust field names based on API response
          relatedCases: item.related_cases,
          billingFees: item.billing_fees || "N/A",
          lawyerNote: item.lawyer_note,
        }));

        setTableData(formattedData);
        // setClientData(clientResponse); 
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (caseId ) fetchData();
  }, [caseId]);

  const onDelClick = () => {
    setIsdelModalOpen(true);
  };

  const columns = [
    {
      title: "ID No",
      dataIndex: "incidentID",
      key: "incidentID",
      render: (text) => (
        <p className="text-darkGrey small font-poppins">{text}</p>
      ),
    },
    {
      title: "Date",
      dataIndex: "caseHistory",
      key: "caseHistory",
      render: (history) => (
        <p className="text-darkGrey small font-poppins">{history}</p>
      ),
    },
    {
      title: "Doc",
      dataIndex: "doc",
      key: "doc",
      // render: (doc) => (
      //   <>
      //     <img
      //       src="../../../../..//assets/icons/doc.png"
      //       alt=""
      //       className="w-[22px] h-[32px]"
      //     />
      //   </>
      // ),
    },
    {
      title: "Next Steps",
      dataIndex: "relatedCases",
      key: "relatedCases",
      render: (relatedCases) => (
        <p className="text-darkGrey small font-poppins">{relatedCases}</p>
      ),
    },
    {
      title: "Lawyer note",
      dataIndex: "lawyerNote",
      key: "lawyerNote",
      render: (lawyerNote) => (
        <p className="text-darkGrey small font-poppins">{lawyerNote}</p>
      ),
    },
    {
      title: "Billing Fees",
      dataIndex: "billingFees",
      key: "billingFees",
      render: (fees) => (
        <p className="text-darkGrey small font-poppins">{fees}</p>
      ),
    },
    // {
    //   title: t("dashboard.incidentDetails.actions"),
    //   key: "actions",
    //   render: () => (
    //     <div className="flex gap-[18px]">
    //       <p
    //         className="text-secondary cursor-pointer flex justify-center items-center small font-poppins w-[83px] h-[34px] bg-[#D3EFF4] rounded-[47px]"
    //         onClick={() => {
    //           navigate("/incident/incident-details");
    //         }}
    //       >
    //         {t("dashboard.incidentDetails.details")}
    //       </p>
    //       <img
    //         src="../../assets/icons/del.png"
    //         alt=""
    //         className="cursor-pointer"
    //         onClick={onDelClick}
    //       />
    //     </div>
    //   ),
    // },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        // dataSource={tableData}
        pagination={{
          position: ["bottomCenter"],
          pageSize: 6,
          itemRender: (current, type, originalElement) => {
            if (type === "prev") {
              return (
                <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                  <Icon icon="ep:arrow-left-bold" color="#143A62" />
                </div>
              );
            }
            if (type === "next") {
              return (
                <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                  <Icon icon="ep:arrow-right-bold" color="#143A62" />
                </div>
              );
            }
            return originalElement;
          },
          showSizeChanger: false,
          className: "custom-pagination",
        }}
        className="w-full"
        scroll={{ x: "1000px" }}
      />
      <DelTableRowModal
        isdelModalOpen={isdelModalOpen}
        setIsdelModalOpen={setIsdelModalOpen}
      />
    </>
  );
};

export default OverviewTable;
